import React from 'react'
import { Excluir } from '@newspacebpo/mf_protocolo_bfveic'
const ExcluirPage = (props) => {
    return (
            <Excluir {...props}/>
    );
};

export { ExcluirPage };